// extracted by mini-css-extract-plugin
export default {"BtnSingIn":"style_BtnSingIn__ypOsc"};